<template lang="pug">
  extends TableRowBase.pug
</template>

<script>
  import TableRowBase from './TableRowBase.vue';

  export default {
    name: 'TableRowMarginPerUnit',
    extends: TableRowBase,
    methods: {
      getCalculatedYtd(yearObj, throughMonth) {
        return this.getRatio(
          this.getYtdByField(yearObj, 'ha_gross_profit', throughMonth),
          (this.getYtdByField(yearObj, 'number_ha_sold', throughMonth)
            - this.getYtdByField(yearObj, 'number_ha_refunded', throughMonth)),
          0,
        );
      },
    },
  };
</script>
